import { useEffect, useState } from "react";

// Wordmarks (logos much wider than tall) get a wide plate instead of the
// square tile, and leave GharSetu's favicon in place, where they would be
// unreadable at 16px.
const WIDE_RATIO = 1.6;

export function useWideLogo(url) {
  const [wide, setWide] = useState(false);

  useEffect(() => {
    setWide(false);
    if (!url) return undefined;
    let cancelled = false;
    const img = new Image();
    img.onload = () => {
      if (!cancelled) setWide(img.naturalWidth / img.naturalHeight > WIDE_RATIO);
    };
    img.src = url;
    return () => {
      cancelled = true;
    };
  }, [url]);

  return wide;
}
